import React from 'react'
import { AiOutlineArrowRight } from 'react-icons/ai'
import logo from '../../assets/images/inferenz-logo.svg'
import recruiter from '../../assets/images/recruiter.svg'
import reimburse from '../../assets/images/reimburse.svg'
// import referral from '../../assets/images/referral.svg'
import exam from '../../assets/images/exam.svg'
import frame from '../../assets/images/Frame.png'
import './Home.css'
import { useNavigate } from 'react-router-dom'

export const Home = () => {
  const role = localStorage.getItem('role')
  const navigate = useNavigate()

  return (
    <div style={{ backgroundColor: '#F5F8FC' }}>
      <div className="container" style={{ backgroundColor: '#F5F8FC' }}>
        <div>
          <nav className="navbar navbar-light bg-light">
            <div className="container">
              <img src={logo} alt="homelogo" height="24" />
            </div>
          </nav>
        </div>

        <div className="row mt-5">
          <div className="col-md-8">
            {role === 'HR' || role === 'Admin' ? (
              <>
                <div className="row">
                  <div className="col-md-5">
                    <div className="card p-3 card1">
                      <div className="row p-2">
                        <div className="col-md-12 card1img d-flex justify-content-center align-items-center mx-2">
                          <img alt="card1image" src={recruiter} />
                        </div>
                        <div className="col-md-12 mt-3">
                          <h6 style={{ fontSize: '20px' }}>Recruiter</h6>
                        </div>
                        <div className="col-md-12 mt-2">
                          <button
                            className="btn card1button d-flex justify-content-between"
                            onClick={() => navigate('/home')}
                          >
                            Get Started{' '}
                            <AiOutlineArrowRight size={20} className="mt-1" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-5">
                    <div className="card p-3 card2">
                      {' '}
                      <div className="row p-2">
                        <div className="col-md-12 card2img d-flex justify-content-center align-items-center mx-2">
                          <img alt="card2image" src={reimburse} />
                        </div>
                        <div className="col-md-12 mt-3">
                          <h6 style={{ fontSize: '20px' }}>Reimbursement</h6>
                        </div>
                        <div className="col-md-12 mt-2">
                          <button
                            className="btn card2button d-flex justify-content-between"
                            onClick={() => {
                              if (role === 'HR') {
                                navigate('/dashboard')
                              } else {
                                navigate('/admindashboard')
                              }
                            }}
                          >
                            Get Started{' '}
                            <AiOutlineArrowRight size={20} className="mt-1" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-5">
                    <div className="card p-3 card3">
                      {' '}
                      <div className="row p-2">
                        <div className="col-md-12 card3img d-flex justify-content-center align-items-center mx-2">
                          <img alt="card3image" src={exam} />
                        </div>
                        <div className="col-md-12 mt-3">
                          <h6 style={{ fontSize: '20px' }}>Exam Simulator</h6>
                        </div>
                        <div className="col-md-12 mt-2">
                          <button
                            className="btn card3button d-flex justify-content-between"
                            onClick={() => navigate('/examdashboard')}
                          >
                            Get Started{' '}
                            <AiOutlineArrowRight size={20} className="mt-1" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-5">
                    <div className="card p-3 card4">
                      {' '}
                      <div className="row p-2">
                        <div className="col-md-12 card4img d-flex justify-content-center align-items-center mx-2">
                          <img alt="card4image" src={referral} />
                        </div>
                        <div className="col-md-12 mt-3">
                          <h6 style={{ fontSize: '20px' }}>Refer a Friend</h6>
                        </div>
                        <div className="col-md-12 mt-2">
                          <button
                            className="btn card4button d-flex justify-content-between"
                            onClick={() => navigate('/add-referral')}
                          >
                            Get Started{' '}
                            <AiOutlineArrowRight size={20} className="mt-1" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </>
            ) : (
              ''
            )}
            {role === 'Interviewer' ? (
              <div className="row">
                <div className="col-md-5">
                  <div className="card p-3 card1">
                    <div className="row p-2">
                      <div className="col-md-12 card1img d-flex justify-content-center align-items-center mx-2">
                        <img alt="card1image" src={recruiter} />
                      </div>
                      <div className="col-md-12 mt-3">
                        <h6 style={{ fontSize: '20px' }}>Recruiter</h6>
                      </div>
                      <div className="col-md-12 mt-2">
                        <button
                          className="btn card1button d-flex justify-content-between"
                          onClick={() => navigate('/InterviewerDashboard')}
                        >
                          Get Started{' '}
                          <AiOutlineArrowRight size={20} className="mt-1" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="card p-3 card5">
                    <div className="row p-2">
                      <div className="col-md-12 card5img d-flex justify-content-center align-items-center mx-2">
                        <img alt="card5image" src={reimburse} />
                      </div>
                      <div className="col-md-12 mt-3">
                        <h6 style={{ fontSize: '20px' }}>Reimbursement</h6>
                      </div>
                      <div className="col-md-12 mt-2">
                        <button
                          className="btn card5button d-flex justify-content-between"
                          onClick={() => navigate('/add-reimburse')}
                        >
                          Get Started{' '}
                          <AiOutlineArrowRight size={20} className="mt-1" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
            {role === 'Employee' ? (
              <div className="row">
                <div className="col-md-5">
                  <div className="card p-3 card5">
                    <div className="row p-2">
                      <div className="col-md-12 card5img d-flex justify-content-center align-items-center mx-2">
                        <img alt="card5image" src={reimburse} />
                      </div>
                      <div className="col-md-12 mt-3">
                        <h6 style={{ fontSize: '20px' }}>Reimbursement</h6>
                      </div>
                      <div className="col-md-12 mt-2">
                        <button
                          className="btn card5button d-flex justify-content-between"
                          onClick={() => navigate('/add-reimburse')}
                        >
                          Get Started{' '}
                          <AiOutlineArrowRight size={20} className="mt-1" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-5">
                  <div className="card p-3 card4">
                    {' '}
                    <div className="row p-2">
                      <div className="col-md-12 card4img d-flex justify-content-center align-items-center mx-2">
                        <img alt="card4image" src={referral} />
                      </div>
                      <div className="col-md-12 mt-3">
                        <h6 style={{ fontSize: '20px' }}>Refer a Friend</h6>
                      </div>
                      <div className="col-md-12 mt-2">
                        <button
                          className="btn card4button d-flex justify-content-between"
                          onClick={() => navigate('/add-referral')}
                        >
                          Get Started{' '}
                          <AiOutlineArrowRight size={20} className="mt-1" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            ) : (
              ''
            )}
            {role === 'Accounts' ? (
              <div className="row">
                <div className="col-md-5">
                  <div className="card p-3 card5">
                    <div className="row p-2">
                      <div className="col-md-12 card5img d-flex justify-content-center align-items-center mx-2">
                        <img alt="card5image" src={reimburse} />
                      </div>
                      <div className="col-md-12 mt-3">
                        <h6 style={{ fontSize: '20px' }}>Reimbursement</h6>
                      </div>
                      <div className="col-md-12 mt-2">
                        <button
                          className="btn card5button d-flex justify-content-between"
                          onClick={() => navigate('/accounts-dashboard')}
                        >
                          Get Started{' '}
                          <AiOutlineArrowRight size={20} className="mt-1" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
          <div className="col-md-4">
            <img src={frame} alt="homeimage" height={400} width={350} />
          </div>
        </div>
      </div>
    </div>
  )
}
